/**
* Endpoint methods related to the Webshop Payment
*/
import API from "./Api";

export default {
  /**
  * Creates a Webshop Payment
  */
  async create(body) {
    return API.post("/webshoppayment/create", body, "MOODLE_SESSION_JSON");
  },

  /**
  * Updates a webshop Payment
  */
  async update(form) {
    return API.post(`/webshoppayment/update/${form.id}`, form, {

    });
  },

  async getAllOwn() {

    return API.get("/webshoppayment/getallown", "COOKIE_TOKEN_SESSION");
  },

  async getOrders(body) {
    return API.post("/webshoppayment/getorders", body, "MOODLE_SESSION_JSON");
  },

  async approve(body) {

    return API.post("/webshoppayment/approveinternalinvoice", body, "MOODLE_SESSION_JSON");
  },


  async decline(body) {

    return API.post("/webshoppayment/declineinternalinvoice", body, "MOODLE_SESSION_JSON");
  },


  async getpendingpayment(body) {
    // const moodleSession = await Csrf.getCookie();
    return API.post("/webshoppayment/getpendingpayment", body, {
      // headers: {
      //   Authorization: 'Bearer ' + localStorage.getItem('token'),
      //   MoodleSession: moodleSession,
      //   'Content-Type': 'application/json'
      // }
    });
  },

  async notify(body) {


    /**
    {
      "to_address" => "recipient@example.com",  // training manager email address
      "template_id" => "27977494",
      "template_parameters" =>   [
          "product_url" => "product_url_Value",
            "product_name" => "product_name_Value",
            "name" => "name_Value",
            "action_url" => "action_url_Value",
            "support_url" => "support_url_Value",
            "company_name" => "company_name_Value",
            "company_address" => "company_address_Value",
            "invoice_id" => "invoice_id_Value",
            "date" => "date_Value",
        ]
    }

     */

    return API.post("/webshoppayment/notify", body, "MOODLE_SESSION_JSON");

  },


};